<button pButton *ngIf="showDeleteButton || canDuplicate()"
        type="button"
        class="neq-primeng-button primeng-flat"
        [matMenuTriggerFor]="additionalMenu">
  <neq-icon svgIcon="additional-menu"></neq-icon>
</button>

<mat-menu #additionalMenu="matMenu">
  <button mat-menu-item (click)="sendResetInput()" *ngIf="showDeleteButton">
    {{ 'msg.common.icon.rawmaterial.input.delete' | translate }}
  </button>
  <button mat-menu-item (click)="duplicate()" *ngIf="canDuplicate()">
    {{ 'msg.action.common.duplicate' | translate }}
  </button>
</mat-menu>
